var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visibleLoading)?_c('div',{staticClass:"loading-container"},[_c('a-spin')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }